import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FilterType } from 'app/components/content-edit/edit-batch/edit-batch.component';
import { A3iService } from 'app/services/a3i.service';
import { Subscription } from 'rxjs';
import { A3iEditCardComponent } from '../a3i-edit-card/a3i-edit-card.component';

@Component({
  selector: 'app-a3i-tab',
  templateUrl: './a3i-tab.component.html',
  styleUrls: ['./a3i-tab.component.css']
})
export class A3iTabComponent implements OnInit, OnDestroy {
	@ViewChild('editCard', { static: false }) editCardComp: A3iEditCardComponent;

	filterTypes: FilterType[] = [
		{
			label: 'Filter Count',
			type: 'filter',
			count: 0
		}, {
			label: 'Select Count',
			type: 'selection',
			count: 0
		}
	];
	selectedFilterType: FilterType;

	parseDisabled: boolean;
	saveParseDisabled: Boolean;
	commitDisabled: boolean;

	private parseDisableSub: Subscription;
	private saveParseDisableSub: Subscription;
	private commitDisableSub: Subscription;
	private clearEditsSub: Subscription;

	constructor(
		private a3iService: A3iService
	) { }

	parse() {
		this.a3iService.parseSubject.next();
	}
	saveParseResult() {
		this.a3iService.saveParseSubject.next();
	}
	commit() {
		this.a3iService.commitSubject.next({
			state: 'start'
		});
	}
	discard() {
		this.editCardComp.clear();
	}
	ngOnInit() {
		this.selectedFilterType = this.filterTypes[0];

		this.parseDisableSub = this.a3iService.parseDisableBS.subscribe(data => {
			this.parseDisabled = data.disabled;
		});
		this.saveParseDisableSub = this.a3iService.saveParseDisableBS.subscribe(data => {
			this.saveParseDisabled = data.disabled;
		})
		this.commitDisableSub = this.a3iService.commitDisableBS.subscribe(data => {
			this.commitDisabled = data.disabled;
		});
		this.clearEditsSub = this.a3iService.clearEditsSubject.subscribe(() => {
			this.discard();
		});
	}
	ngOnDestroy(): void {
		this.parseDisableSub.unsubscribe();
		this.saveParseDisableSub.unsubscribe();
		this.commitDisableSub.unsubscribe();
		this.clearEditsSub.unsubscribe();
	}
}
